/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

import { store } from '@/store/store.js'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            meta: {
              requiresAuth: true
            },
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue')
              },
              {
                path: '/imagenes',
                name: 'imagenes',
                component: () => import('./views/Imagenes.vue')
              },
              {
                path: '/categorias-blog',
                name: 'categorias-blog',
                component: () => import('./views/blog/categorias/Index.vue')
              },
              {
                path: '/categorias-blog/editar/:slug',
                name: 'categorias-blog-editar-slug',
                component: () => import('./views/blog/categorias/Editar.vue')
              },
              {
                path: '/blog',
                name: 'blog',
                component: () => import('./views/blog/Index.vue')
              },
              {
                path: '/blog/detalles/:slug',
                name: 'blog-detalles-slug',
                component: () => import('./views/blog/slug/Index.vue')
              },
              {
                path: '/blog/crear',
                name: 'blog-crear',
                component: () => import('./views/blog/Crear.vue')
              },
              { 
                path: '/blog/editar/:slug',
                name: 'blog-editar-slug',
                component: () => import('./views/blog/Editar.vue')
              },
              {
                path: '/pedidos',
                name: 'pedidos',
                component: () => import('./views/pedidos/Index.vue')
              },
              {
                path: '/pedidos/:id',
                name: 'pedidos-id',
                component: () => import('./views/pedidos/detalles/Index.vue')
              },
              {
                path: '/productos',
                name: 'productos',
                component: () => import('./views/productos/Index.vue')
              },
              {
                path: '/productos/crear',
                name: 'productos-crear',
                component: () => import('./views/productos/Crear.vue')
              },
              {
                path: '/productos/editar/:slug',
                name: 'productos-editar-slug',
                component: () => import('./views/productos/Editar.vue')
              },
              {
                path: '/productos/edicion-rapida',
                name: 'edicion-rapida',
                component: () => import('./views/productos/EdicionRapida.vue')
              },
              {
                path: '/packs',
                name: 'packs',
                component: () => import('./views/packs/Index.vue')
              },
              {
                path: '/packs/crear',
                name: 'packs-crear',
                component: () => import('./views/packs/Crear.vue')
              },
              {
                path: '/packs/editar/:slug',
                name: 'packs-editar',
                component: () => import('./views/packs/Editar.vue')
              },
              {
                path: '/codigos-descuento',
                name: 'codigos-descuento',
                component: () => import('./views/codigos-descuento/Index.vue')
              },
              {
                path: '/codigos-descuento/crear',
                name: 'codigos-descuento-crear',
                component: () => import('./views/codigos-descuento/Crear.vue')
              },
              {
                path: '/codigos-descuento/editar/:codigo',
                name: 'codigos-descuento-editar',
                component: () => import('./views/codigos-descuento/Editar.vue')
              },
              {
                path: '/categorias-productos',
                name: 'categorias-productos',
                component: () => import('./views/productos/categorias/Index.vue')
              },
              {
                path: '/categorias-productos/editar/:slug',
                name: 'categorias-productos-editar',
                component: () => import('./views/productos/categorias/Editar.vue')
              },
              {
                path: '/tallas',
                name: 'tallas',
                component: () => import('./views/tallas/Index.vue')
              },
              {
                path: '/distritos',
                name: 'distritos',
                component: () => import('./views/distritos/Index.vue')
              },
              {
                path: '/bancos',
                name: 'bancos',
                component: () => import('./views/bancos/Index.vue')
              },
              {
                path: '/bancos/crear',
                name: 'bancos-crear',
                component: () => import('./views/bancos/Crear.vue')
              },
              {
                path: '/bancos/editar/:id',
                name: 'bancos-editar-id',
                component: () => import('./views/bancos/Editar.vue')
              },
              {
                path: '/efectivo-movil',
                name: 'efectivo-movil',
                component: () => import('./views/efectivo-movil/Index.vue')
              },
              {
                path: '/efectivo-movil/crear',
                name: 'efectivo-movil-crear',
                component: () => import('./views/efectivo-movil/Crear.vue')
              },
              {
                path: '/efectivo-movil/editar/:id',
                name: 'efectivo-movil-editar-id',
                component: () => import('./views/efectivo-movil/Editar.vue')
              },
              {
                path: '/banners',
                name: 'banners',
                component: () => import('./views/banners/Index.vue')
              },
              {
                path: '/banners/crear',
                name: 'banners-crear',
                component: () => import('./views/banners/Crear.vue')
              },
              {
                path: '/banners/editar/:id',
                name: 'banners-editar-id',
                component: () => import('./views/banners/Editar.vue')
              },
              {
                path: '/ofertas',
                name: 'ofertas',
                component: () => import('./views/ofertas/Index.vue')
              },
              {
                path: '/ofertas/crear',
                name: 'ofertas-crear',
                component: () => import('./views/ofertas/Crear.vue')
              },
              {
                path: '/ofertas/editar/:slug',
                name: 'ofertas-editar-slug',
                component: () => import('./views/ofertas/Editar.vue')
              },
              {
                path: '/costo-envios',
                name: 'costo-envios',
                component: () => import('./views/costo-envios/Index.vue')
              },
              {
                path: '/usuarios',
                name: 'usuarios',
                component: () => import('./views/usuarios/Index.vue')
              },
              {
                path: '/usuarios/editar/:id',
                name: 'usuarios-editar-id',
                component: () => import('./views/usuarios/editar/Index.vue')
              },
              {
                path: '/suscriptores',
                name: 'suscriptores',
                component: () => import('./views/suscriptores/Index.vue')
              }
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth),
  currentUser = store.state.currentUser

  if (requiresAuth && !currentUser) {
    next({name: 'page-login'})
  } else if(requiresAuth && currentUser) {
    next()
  } else if(to.name === 'page-login' && currentUser) {
    next('/productos')
  } else {
    next()
  }
})

export default router
